if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-apply]').addEventListener('click', () => this.update(false));
      this.querySelector('input').addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.update(false);
        }
      });
    }

    async update(remove, removeCode = '') {
      if (document.querySelector('cart-discount[aria-busy="true"]')) return;
      const input = this.querySelector('input');
      const code = input.value.trim();
      if (!remove && !code) {
        input.focus();
        this.querySelector('[role="status"]').textContent = this.dataset.invalid;
        return;
      }
      const id = this.id;
      const discountExpanded = this.closest('details')?.open;
      const messages = { ...this.dataset };
      const controls = [...document.querySelectorAll('cart-discount input, cart-discount button, [data-remove-code], button[name="checkout"]')];
      const disabled = controls.map((control) => control.disabled);
      const sections = [];
      const items = document.getElementById('main-cart-items');
      const footer = document.getElementById('main-cart-footer');
      if (items) sections.push({ section: items.dataset.id, target: '#main-cart-items .js-contents' });
      if (footer) sections.push({ section: footer.dataset.id, target: '#main-cart-footer .cart__blocks' });
      if (document.querySelector('cart-drawer')) sections.push({ section: 'cart-drawer', target: '#CartDrawer .drawer__inner' });
      if (document.getElementById('cart-icon-bubble')) sections.push({ section: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' });
      this.setAttribute('aria-busy', 'true');
      controls.forEach((control) => { control.disabled = true; });
      this.querySelector('[role="status"]').textContent = '';
      try {
        const previousCodes = [];
        if (!remove || removeCode) {
          const response = await fetch(window.Shopify.routes.root + 'cart.js', {
            headers: { Accept: 'application/json' }, cache: 'no-store',
          });
          if (!response.ok) throw new Error('Cart read failed');
          const previous = await response.json();
          const applied = Array.isArray(previous.discount_codes)
            ? previous.discount_codes.filter((entry) => entry.applicable).map((entry) => entry.code)
            : [...this.querySelectorAll('[data-code]')].map((badge) => badge.dataset.code);
          previousCodes.push(...applied);
        }
        const requestedCodes = code.split(',').map((value) => value.trim()).filter(Boolean);
        const combinedCodes = [...new Map([...previousCodes, ...requestedCodes].map((value) => [value.toLowerCase(), value])).values()];
        const remainingCodes = previousCodes.filter((value) => value.toLowerCase() !== removeCode.toLowerCase());
        const updateCart = async (discount) => {
          const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount, sections: sections.map((entry) => entry.section), sections_url: window.location.pathname }),
          });
          const result = await response.json();
          if (!response.ok || result.errors) {
            const error = new Error('Cart update failed');
            if (typeof result.description === 'string') error.shopifyMessage = result.description;
            else if (typeof result.errors === 'string') error.shopifyMessage = result.errors;
            throw error;
          }
          return result;
        };
        let cart = await updateCart(remove ? remainingCodes.join(',') : combinedCodes.join(','));
        const appliedCodes = Array.isArray(cart.discount_codes)
          ? cart.discount_codes.filter((entry) => entry.applicable).map((entry) => entry.code)
          : Object.values(cart.sections || {}).filter(Boolean).flatMap((markup) => {
            const html = new DOMParser().parseFromString(markup, 'text/html');
            return [...html.querySelectorAll('cart-discount [data-code]')].map((entry) => entry.dataset.code);
          });
        const rejected = !remove && requestedCodes.some((requested) =>
          !appliedCodes.some((applied) => applied.toLowerCase() === requested.toLowerCase())
        );
        if (rejected) cart = await updateCart(previousCodes.join(','));
        for (const entry of sections) {
          const markup = cart.sections?.[entry.section];
          if (!markup) throw new Error('Cart section unavailable');
          const html = new DOMParser().parseFromString(markup, 'text/html');
          const source = html.querySelector(entry.source || entry.target);
          const target = document.querySelector(entry.target);
          if (!source || !target) throw new Error('Cart section unavailable');
          target.innerHTML = source.innerHTML;
        }
        const current = document.getElementById(id);
        if (current) {
          const details = current.closest('details');
          if (details) details.open = Boolean(discountExpanded || rejected);
          const codes = cart.discount_codes;
          current.querySelector('[role="status"]').textContent = rejected ? messages.invalid : '';
          if (Array.isArray(codes)) {
            document.querySelectorAll('cart-discount').forEach((component) => {
              const applied = component.querySelector('[data-applied]');
              codes.filter((entry) => entry.applicable).forEach((entry) => {
                const exists = [...applied.querySelectorAll('[data-code]')].some((badge) => badge.dataset.code.toLowerCase() === entry.code.toLowerCase());
                if (exists) return;
                const badge = document.createElement('span');
                badge.dataset.code = entry.code;
                applied.append(badge);
              });
            });
          }
          if (!remove && rejected) current.querySelector('input').value = code;
          const drawer = current.closest('cart-drawer');
          const focusTarget = details && !details.open ? details.querySelector('summary') : current.querySelector('input');
          if (drawer?.classList.contains('active') && typeof trapFocus === 'function') {
            trapFocus(drawer.querySelector('.drawer__inner'), focusTarget);
          } else {
            focusTarget.focus();
          }
        }
      } catch (error) {
        const current = document.getElementById(id);
        if (current) current.querySelector('[role="status"]').textContent = error.shopifyMessage || messages.error;
      } finally {
        controls.forEach((control, index) => { if (control.isConnected) control.disabled = disabled[index]; });
        this.removeAttribute('aria-busy');
      }
    }
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-remove-code]');
    if (!button || button.disabled) return;
    const scope = button.closest('cart-drawer') || button.closest('#main-cart-footer');
    const component = scope?.querySelector('cart-discount');
    if (component) {
      event.preventDefault();
      component.update(true, button.dataset.removeCode);
    }
  });
}
